import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { confirmDialog } from "primereact/confirmdialog";
import { Badge } from "primereact/badge";

// ------------------ COMPONENTES DE BASE--------------------------
import Card from "../../../../../Base/Components/Card/Card";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../Base/Services/ToastService";

import { getPersonal } from "../../../../../API/RRHH/Personal/PersonalRequests";
import { EliminarAsignacion, getAsignaciones } from "../../../../../API/Mantenimiento/OrdenesTrabajo/OrdenesTrabajoRequest";

import { colorsStatus } from "../../../../../Styles/coloresEstados";


const SubTareasCRUD = ({detalleSeleccionado, modalAsignaciones, setModalAsignaciones, asignaciones, setAsignaciones, agregarAsignacion}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [personal, setPersonal] = useState([]);
  const [errores, setErrores] = useState([]); 

  const getInfo = async () => {
    setLoading(true);
    const personalTempo = await getPersonal();
    const personalFiltrado = personalTempo.filter((persona) => persona.IdTipoTrabajo === detalleSeleccionado?.IdTipoTrabajo);
    setPersonal(personalFiltrado);
    
    
    if(detalleSeleccionado?.IdOrdenDeTrabajoDet > 0){
      const subTareasTempo = await getAsignaciones(detalleSeleccionado?.IdOrdenDeTrabajoDet)
  
      const subTareasMapeadas = subTareasTempo?.map((subTarea) => ({
        ...subTarea,
        IdPersonal: subTarea?.IdPersonal ? subTarea.IdPersonal.split(',').map(id => parseInt(id.trim(), 10)) : [], 
      }));
      setAsignaciones(subTareasMapeadas);
    }else{
      setAsignaciones(detalleSeleccionado?.Asignaciones ? detalleSeleccionado?.Asignaciones : [] )
    }
    setLoading(false);
  };

  const agregarNuevaCard = () => {
    let newRowData = [...asignaciones];
    let IdDet = -(asignaciones?.length + 1);
  
    const newData = {
      IdAsignacion: IdDet,
      IdOrdenDeTrabajoDet: detalleSeleccionado?.IdOrdenDeTrabajoDet || "",
      DescripcionSubTareas: "",
      IdPersonal: null,
      Comentario: "",
      NombreConcatenado: "",
      IdEstado: 48,
      StatusName: "Asignado",
    };
  
    if (newRowData.length > 0) {
      const lastTask = newRowData[newRowData.length - 1];
      if (!lastTask.IdAsignacion) {
        newRowData[newRowData.length - 1] = newData;
      } else {
        newRowData.push(newData);
      }
    } else {
      newRowData.push(newData);
    }
  
    setAsignaciones(newRowData);
  };

  const eliminarSubTarea = (selected) => {
    if(selected?.IdEstado === 52){
      toastShow(toast, "warn", "Advertencia", "No se pueden eliminar tareas en Revisión");
      return;
    }

    if(selected?.IdEstado === 69){
      toastShow(toast, "warn", "Advertencia", "No se pueden eliminar tareas Finalizadas");
      return;
    }
    
    confirmDialog({
      message: "¿Estás seguro de eliminar la sub tarea?",
      header: "Eliminar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      accept: () => {
        eliminar(selected)
      },
      rejectLabel: "No",
      reject: () => {}, // No hacer nada si el usuario cancela
      style: { backgroundColor: "white" },
    });
  };

  const eliminar = async (selected) => {
    const deleteSubTareas = {
      ...selected,
      IdUserDelete: userAuth?.IdUser
    };
    const respuesta = await EliminarAsignacion(deleteSubTareas)
    if(respuesta[0]?.ESTADO === 1){
      toastShow(toast, "success", "Eliminada", respuesta[0]?.MENSAJE);
      getInfo()
    }else{
      toastShow(toast, "error", "Error", respuesta[0]?.MENSAJE);
    }
  };

  const verificarCampos = () => {
    let err = false;
    const erroresEncontrados = [];
  
    asignaciones.forEach((item) => {
      if (!item.DescripcionSubTareas) {
        erroresEncontrados.push(item.IdAsignacion);
        toastShow(toast, "error", "Error", "La descripción es requerida.");
        err = true
        return
      }
      if(!item.IdPersonal || item.IdPersonal.length === 0){
        erroresEncontrados.push(item.IdAsignacion);
        toastShow(toast, "error", "Error", "Agrega al menos una persona asignada.");
        err = true
        return
      }
    });
  
    setErrores(erroresEncontrados);
  

    return !err
  }

  const asignarValues = () => {
    if(verificarCampos()){
      setLoading(true)
      setTimeout(() => {
        agregarAsignacion()
        setLoading(false)
        setModalAsignaciones(false);
      }, 800);
    }
  };



  useEffect(() => {
    getInfo();
  }, [modalAsignaciones]);

  return (
    <div style={{ width: "100%" }}>
      <Loader loading={loading} />
      <Toast ref={toast} />

      {/* BOTONES */}
      <div className="d-flex flex-wrap gap-2 mx-2">
        <Button
          icon="pi pi-plus"
          type="button"
          className="encabezado__herramienta-botones"
          tooltip="Agregar Sub Tarea"
          tooltipOptions={{
            className: "purple-tooltip",
            position: "top",
          }}
          onClick={(e) => {
            // agregarNuevaFila();
            agregarNuevaCard();
          }}
          tabIndex={7}
        />

        <Button
          label="Agregar"
          type="button"
          className="encabezado__herramienta-botones"
          tooltip="Agregar"
          tooltipOptions={{
            className: "purple-tooltip",
            position: "top",
          }}
          disabled={asignaciones.length <= 0}
          onClick={(e) => {
            asignarValues();
          }}
          tabIndex={7}
        />
      </div>

      <div className="cards-container" style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
        {asignaciones.map((item, index) => (
          <Card
            key={item.IdAsignacion}
            // style={{backgroundColor: errores.includes(item.IdAsignacion) ? "#ffedf0" : null}}
            contenido={
              <div style={{ width: "55vh" }}>
                <div className="d-flex justify-content-end py-1">
                  <Badge value={item.StatusName} style={colorsStatus["status" + item.IdEstado]} />
                  <Button
                    icon="pi pi-trash"
                    type="button"
                    className="p-button-text p-button-danger"
                    tooltip="Eliminar Sub Tarea"
                    onClick={() => {
                      if (item?.IdAsignacion > 0) {
                        eliminarSubTarea(item);
                      } else {
                        setAsignaciones(asignaciones.filter((_, i) => i !== index));
                      }
                    }}
                  />
                </div>

                <div className="mt-2">
                  <div className="field me-2 mx-2">
                    <span className="p-float-label">
                      <InputText
                        name="DescripcionSubTareas"
                        value={item?.DescripcionSubTareas}
                        onChange={(e) => {
                          const updatedSubTareas = [...asignaciones];
                          updatedSubTareas[index].DescripcionSubTareas = e.target?.value;
                          setAsignaciones(updatedSubTareas);
                        }}
                        style={{ width: "100%" }}
                        autoComplete="off"
                      />
                      <label>Descripcion</label>
                    </span>
                  </div>

                  <div className="field me-2 mt-4 mx-2">
                    <span className="p-float-label">
                      <MultiSelect
                        name="IdPersonal"
                        value={item.IdPersonal}
                        onChange={(e) => {
                          const updatedSubTareas = [...asignaciones];
                          updatedSubTareas[index].IdPersonal = e.value;
                          updatedSubTareas[index].NombreConcatenado = personal.find(
                            (p) => p.IdPersonal === e.value
                          )?.NombreConcatenado;
                          setAsignaciones(updatedSubTareas);
                        }}
                        options={personal}
                        style={{ width: "100%", zIndex: 1000000 }}
                        optionLabel="NombreConcatenado"
                        optionValue="IdPersonal"
                        filter
                        placeholder="Seleccione personal"
                      />
                      <label>Personal Asignado</label>
                    </span>
                  </div>

                  <Card
                    titulo={"Personal Asignado"}
                    contenido={
                      <div style={{ marginBottom: "8px" }}>
                        {item.IdPersonal?.length > 0 ? (
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(2, 1fr)",
                              gap: "8px",
                            }}
                          >
                            {item.IdPersonal.map((id) => {
                              const person = personal.find(
                                (p) => p.IdPersonal === id
                              );
                              return (
                                <span
                                  key={id}
                                  style={{
                                    backgroundColor: "#e5f8fd",
                                    padding: "2px 8px",
                                    borderRadius: "16px",
                                    fontSize: "12px",
                                    color: "#333",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                  }}
                                >
                                  {person?.NombreCompleto || "Sin nombre"}
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          "No se ha seleccionado personal"
                        )}
                      </div>
                    }
                  />
                </div>
              </div>
            }
          />
        ))}
      </div>



    </div>
  );
};
export default SubTareasCRUD;
